module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    attrs: {
      "id": "site-wrapper"
    }
  }, [_c('header', {
    attrs: {
      "id": "site-header"
    }
  }, [_c('div', {
    staticClass: "nav-top"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('ul', [(_vm.timeData.special.from == 0 || _vm.timeData.special.from >= (Date.now() / 1000 | 0) || _vm.timeData.special.to <= (Date.now() / 1000 | 0)) ? _c('li', [_c('i', {
    staticClass: "fa fa-clock-o"
  }), _vm._v("Aujourd'hui: " + _vm._s(_vm.todayTime))]) : _vm._e(), _vm._v(" "), (_vm.timeData.special.from != 0 && _vm.timeData.special.from < (Date.now() / 1000 | 0) && _vm.timeData.special.to > (Date.now() / 1000 | 0)) ? _c('li', [_c('i', {
    staticClass: "fa fa-clock-o"
  }), _vm._v("Aujourd'hui: " + _vm._s(_vm.timeData.special.time))]) : _vm._e(), _vm._v(" "), _vm._m(1), _vm._v(" "), _vm._m(2)])])])])]), _vm._v(" "), _c('div', {
    staticClass: "navbar",
    attrs: {
      "role": "navigation"
    }
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('h1', {
    staticClass: "sr-only"
  }, [_vm._v("La Pizzetta")]), _vm._v(" "), _vm._m(3), _vm._v(" "), _vm._m(4), _vm._v(" "), _c('ul', {
    staticClass: "nav navbar-nav navbar-collapse collapse"
  }, [_c('li', [_c('a', {
    class: {
      active: _vm.$route.name == 'Accueil'
    },
    attrs: {
      "href": "#/"
    }
  }, [_vm._v("accueil")])]), _vm._v(" "), _c('li', [_c('a', {
    class: {
      active: _vm.$route.name == 'Carte des mets'
    },
    attrs: {
      "href": "#/menu"
    }
  }, [_vm._v("carte des mets")])]), _vm._v(" "), _vm._m(5), _vm._v(" "), _vm._m(6)])])])])]), _vm._v(" "), _c('section', {
    staticClass: "parallax-window",
    class: {
      reduced: _vm.$route.name == 'Carte des mets'
    },
    attrs: {
      "id": "main-slider",
      "data-background": "static/img/bg/pizza.jpg"
    }
  }, [(_vm.$route.name == 'Accueil') ? _c('div', [_vm._m(7), _vm._v(" "), _c('span', {
    staticClass: "scoll-down"
  }, [_vm._v("Défiler vers le bas")])]) : _vm._e(), _vm._v(" "), (_vm.$route.name != 'Accueil') ? _c('div', [_c('h1', {
    staticClass: "section-title white-font text-center"
  }, [_vm._v(_vm._s(_vm.$route.name))]), _vm._v(" "), _c('ul', [_vm._m(8), _vm._v(" "), _c('li', [_vm._v(_vm._s(_vm.$route.name))])])]) : _vm._e()]), _vm._v(" "), _c('router-view'), _vm._v(" "), _vm._m(9), _vm._v(" "), _c('footer', {
    attrs: {
      "id": "site-footer"
    }
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_vm._m(10), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6 col-md-6"
  }, [_c('div', {
    staticClass: "open-hours"
  }, [(_vm.timeData.special.from != 0) ? _c('div', [_c('span', {
    staticClass: "foot-title"
  }, [_vm._v(_vm._s(_vm.timeData.special.name))]), _vm._v(" "), _c('span', {
    staticClass: "time"
  }, [_vm._v(_vm._s(_vm.timeData.special.digest))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.timeData.special.time))])]) : _vm._e(), _vm._v(" "), _c('span', {
    staticClass: "foot-title"
  }, [_vm._v("Horaires d'ouverture")]), _vm._v(" "), _c('table', _vm._l((_vm.timeData.compact), function(time) {
    return _c('tr', [_c('td', [_vm._v(_vm._s(time.days))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(time.time))])])
  }))])])])]), _vm._v(" "), _vm._m(11)])], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "site-loader"
  }, [_c('div', {
    staticClass: "loading"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('i', {
    staticClass: "fa fa-phone"
  }), _vm._v("021 944 04 03")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', {
    staticClass: "social-bloc"
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "https://www.facebook.com/lapizzetta.ch/"
    }
  }, [_c('i', {
    staticClass: "fa fa-facebook"
  })]), _vm._v(" "), _c('a', {
    attrs: {
      "target": "_blank",
      "href": "https://fr.tripadvisor.ch/Restaurant_Review-g1130892-d12355409-Reviews-La_Pizzetta-La_Tour_de_Peilz_Canton_of_Vaud.html"
    }
  }, [_c('i', {
    staticClass: "fa fa-tripadvisor"
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "logo",
    attrs: {
      "href": "index.html",
      "title": "La Pizzetta"
    }
  }, [_c('img', {
    attrs: {
      "src": "static/img/logo-flat.svg",
      "alt": "",
      "width": "170"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "menu-mobile visible-xs",
    attrs: {
      "data-target": ".navbar-collapse",
      "data-toggle": "collapse",
      "type": "button"
    }
  }, [_c('span', {
    staticClass: "icon-bar"
  }), _vm._v(" "), _c('span', {
    staticClass: "icon-bar"
  }), _vm._v(" "), _c('span', {
    staticClass: "icon-bar"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('a', {
    attrs: {
      "onclick": "$('html,body').animate({scrollTop: $('#contact').offset().top},1500,'easeInOutQuad');"
    }
  }, [_vm._v("contact")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', {
    staticClass: "uber"
  }, [_c('a', {
    attrs: {
      "href": "https://www.ubereats.com/ch/store/la-pizzetta/Snc5SHZ5SJ2AUr5MTHHiKQ",
      "target": "_blank"
    }
  }, [_vm._v("Livraison  "), _c('img', {
    attrs: {
      "src": "static/img/ubereats.svg",
      "height": "10px",
      "alt": "Uber Eats"
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "section-slogan"
  }, [_c('img', {
    attrs: {
      "src": "static/img/logo.svg",
      "alt": ""
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('a', {
    attrs: {
      "href": "#/"
    }
  }, [_vm._v("Accueil")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    attrs: {
      "id": "contact"
    }
  }, [_c('div', {
    attrs: {
      "id": "maps"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-8 col-md-4"
  }, [_c('div', {
    staticClass: "ctc-item"
  }, [_c('span', {
    staticClass: "section-suptitle text-center"
  }, [_vm._v("\n\t\t\t\t\t\t\t\tContact\n\t\t\t\t\t\t\t")]), _vm._v(" "), _c('h2', {
    staticClass: "section-title sep-type-2 text-center"
  }, [_vm._v("\n                    Commandez vos mets\n                  ")]), _vm._v(" "), _c('p', {
    staticClass: "tel"
  }, [_vm._v("021 944 04 03")]), _vm._v(" "), _c('div', {
    staticClass: "widget"
  }, [_c('b', [_vm._v("Adresse")]), _vm._v(" "), _c('p', [_vm._v("\n                      La Pizzetta"), _c('br'), _vm._v("\n                      Grand-Rue 5"), _c('br'), _vm._v("\n                      1814 La Tour-de-Peilz\n                    ")])])])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-sm-6 col-md-6"
  }, [_c('div', {
    staticClass: "bloc-cms"
  }, [_c('img', {
    attrs: {
      "src": "static/img/logo-flat.svg",
      "alt": ""
    }
  }), _vm._v(" "), _c('p', [_vm._v("\n                    La pizza traditionnelle à longue maturation,"), _c('br'), _vm._v("\n                    à emporter chez vous."), _c('br'), _vm._v("\n                    Possibilité, aussi, de la déguster sur place.\n                  ")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "footer-end"
  }, [_c('div', {
    staticClass: "social"
  }, [_c('ul', [_c('li', {
    staticClass: "social-bloc"
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "https://www.facebook.com/lapizzetta.ch/"
    }
  }, [_c('i', {
    staticClass: "fa fa-facebook"
  })]), _vm._v(" "), _c('a', {
    attrs: {
      "target": "_blank",
      "href": "https://fr.tripadvisor.ch/Restaurant_Review-g1130892-d12355409-Reviews-La_Pizzetta-La_Tour_de_Peilz_Canton_of_Vaud.html"
    }
  }, [_c('i', {
    staticClass: "fa fa-tripadvisor"
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "top"
  }, [_c('a', {
    attrs: {
      "href": ""
    }
  }, [_vm._v("Revenir en haut")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-e9457bc2"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 16
// module chunks = 0